/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-collaborate': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M3.75 13.125V12.5H2.5v.625A4.375 4.375 0 006.875 17.5H8.75v-1.25H6.875a3.125 3.125 0 01-3.125-3.125zM15 6.875V7.5h1.25v-.625A4.375 4.375 0 0011.875 2.5H10v1.25h1.875A3.125 3.125 0 0115 6.875zm-8.125 0h-3.75c-1.036 0-1.875.84-1.875 1.875V10H2.5V8.75c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625V10h1.25V8.75c0-1.036-.84-1.875-1.875-1.875zM5 6.25a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM5 2.5A1.25 1.25 0 115 5a1.25 1.25 0 010-2.5zm11.875 13.125h-3.75c-1.036 0-1.875.84-1.875 1.875v1.25h1.25V17.5c0-.345.28-.625.625-.625h3.75c.345 0 .625.28.625.625v1.25h1.25V17.5c0-1.036-.84-1.875-1.875-1.875zM12.5 12.5a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0zm3.75 0a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"/>'
  }
})
